import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Table,
  CircularProgress,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  TablePagination,MenuItem,Select,InputLabel,FormControl
} from "@mui/material";
import { useNavigate } from "react-router-dom";
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Divider,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { GlobalStyles } from "@mui/system";
import GroupIcon from "@mui/icons-material/Group";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { IoIosPeople } from "react-icons/io";
import { BsPersonCheckFill } from "react-icons/bs";
import { BsFillPersonXFill } from "react-icons/bs";
import { format } from "date-fns"; // Import the format function
import { useAuth } from "../../AuthProvider";

import { FaBuilding, FaUserTie, FaUserGraduate, FaUsersCog } from "react-icons/fa"; // Font Awesome icons

import GroupsIcon from '@mui/icons-material/Groups';


const baseUrl = process.env.REACT_APP_API_BASE_URL;
const SuperAdminDashboard = () => {
  const [employeeCount, setEmployeeCount] = useState(0);
  const [organizationsCount, setOrganizationCount] = useState(0);
  const [organization, setOrganization  ] = useState([]);
  const [loader, setLoader] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const navigate = useNavigate();
  const [isEditingCheckIn, setIsEditingCheckIn] = useState(false); // State to toggle check-in input field
  const [isEditingCheckOut, setIsEditingCheckOut] = useState(false); // State to toggle check-out input field

  const { oId ,pId} = useAuth();

  const [dateRange, setDateRange] = useState("All");




  const fetchOrganizationCount = async () => {
    try {
      let endpoint = "";
     
      switch (dateRange) { // ✅ Changed to 'dateRange'
        case "SSC":
          endpoint = `${baseUrl}/api/superAdmin/counts/organisationDashboard?boardAffiliation=SSC`;
          break;
        case "INTERMEDIATE":
          endpoint = `${baseUrl}/api/superAdmin/counts/organisationDashboard?boardAffiliation=INTERMEDIATE`;
          break;
         case "All":
          endpoint = `${baseUrl}/api/superAdmin/counts/organisationDashboard`;
          break;
       
        default:
          endpoint = `${baseUrl}/api/superAdmin/counts/organisationDashboard`;
          break;
      }
 
      const response = await fetch(endpoint);
      if (!response.ok) throw new Error("Failed to fetch data");
 
      const data = await response.json();
     setOrganizationCount(data); // Update present count
     
    } catch (error) {
      console.error("Error fetching Organization Data:", error);
    }
  };
 
  useEffect(() => {
    fetchOrganizationCount();
  }, [dateRange]);
 




  const fetchAllOrganizationsList = async () => {
    try {
       setLoader(true);
      let endpoint = "";
     
      switch (dateRange) { // ✅ Changed to 'dateRange'
        case "SSC":
          endpoint = `${baseUrl}/api/superAdmin/getAllOrganisationList?boardAffiliation=SSC`;
          break;
        case "INTERMEDIATE":
          endpoint = `${baseUrl}/api/superAdmin/getAllOrganisationList?boardAffiliation=INTERMEDIATE`;
          break;
         case "All":
          endpoint = `${baseUrl}/api/superAdmin/getAllOrganisationList`;
          break;
       
        default:
          endpoint = `${baseUrl}/api/superAdmin/getAllOrganisationList`;
          break;
      }
 
      const response = await fetch(endpoint);
       if (!response.ok) {
        // If API returns non-2xx status
        console.warn("Organization List fetch failed with status:", response.status);
        setOrganization([]); // fallback to empty data
        return;
      }

      const data = await response.json();
      setOrganization(data || []);
    } catch (error) {
      console.error("Failed to fetch Data", error);
      setOrganization([]); // fallback to empty data
    } finally {
      setLoader(false);
    }
  };
 
  useEffect(() => {
    fetchAllOrganizationsList();
  }, [dateRange]);
 









const getCardStyle = (bgColor) => ({
  backgroundColor: bgColor,
  borderRadius: "12px",
  padding: "20px",
  color: "#fff",
  minHeight: "100px",
  cursor: "pointer",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.1)",
});

const iconContainerStyle = {
  width: "50px",
  height: "50px",
  borderRadius: "50%",
  backgroundColor: "rgba(255, 255, 255, 0.2)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const cards = [
  {
    label: "TOTAL ORGANIZATIONS",
    count: organizationsCount.organisationCount || 0,
    color: "#6C63FF",
     icon: <FaBuilding size={24} />, // 🏢 Building icon for organizations
    path: `/SuperAdminOrganizationsList?dateRange=${dateRange}`,
  },
   {
    label: "TOTAL PRINCIPALS",
    count: organizationsCount.totalPrincipals || 0,
    color: "#28466b",
    icon: <FaUserTie size={24} />, // 👔 Represents principals/admins
    path: `/SuperAdminPrincipalsList?dateRange=${dateRange}`,
  },
  {
    label: "TOTAL STUDENTS",
    count: organizationsCount.totalPresentStudents || 0,
    color: "#00B894",
     icon: <FaUserGraduate size={24} />, // 🎓 Perfect for students
    // path: "/EmployeeAttendance",
  },
  {
    label: "TOTAL EMPLOYEES",
    count: organizationsCount.totalPresentEmployees || 0,
    color: "#FD7272",
    icon: <GroupsIcon size={24} />, // 👥👷 Represents employees/staff
    // path: "/AbsentsList",
  },
];







  return (
    <Box p={3} marginTop={9}>
    
<Grid container spacing={2}>
  {cards.map((card, idx) => (
    <Grid item xs={12} sm={3} key={idx}>
      <Paper
        elevation={3}
        onClick={() => navigate(card.path)}
        sx={{
          ...getCardStyle(card.color),
          "&:hover": {
            transform: "translateY(-5px)",
            boxShadow: "0px 12px 20px rgba(0, 0, 0, 0.15)",
          },
        }}
      >
        <Grid container alignItems="center">
          <Grid item>
            <div style={iconContainerStyle}>{card.icon}</div>
          </Grid>
          <Grid item xs>
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", textAlign: "center" }}
              >
                {card.label}
              </Typography>
              <Typography
                variant="h4"
                sx={{ fontWeight: "bold", textAlign: "center" }}
              >
                {card.count}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  ))}
</Grid>



      <Box mt={5}>
        <Card
          sx={{
            backgroundColor: "white",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
          }}
        >

<Box
  display="flex"
  justifyContent="space-between"
  alignItems="center"
  mb={2}
>
  {/* Empty Box to occupy left space */}
  <Box width="150px" />

  {/* Centered Typography */}
  <Typography sx={{ fontSize: 18, padding: 1, textAlign: "center" }}>
    <strong style={{ padding: 12 }}>Registered Organizations Details</strong>
  </Typography>

  {/* FormControl on the right */}
  <FormControl
    variant="outlined"
    size="small"
    sx={{
      width: "150px",
      height: "30px",
      marginTop:'2px',
      marginRight:'15px'
    }}
  >
    <InputLabel>Select Board</InputLabel>
    <Select
      value={dateRange}
      onChange={(e) => setDateRange(e.target.value)}
      label="Select Board"
      sx={{ height: "30px", fontSize: "12px" }}
    >
      <MenuItem value="All">All</MenuItem>
      <MenuItem value="SSC">SSC</MenuItem>
      <MenuItem value="INTERMEDIATE">INTERMEDIATE</MenuItem>
    </Select>
  </FormControl>
</Box>



          <CardContent>
            <GlobalStyles
              styles={{
                ".custom-sidebar-scrollbar": {
                  scrollbarWidth: "thin", // For Firefox
                  scrollbarColor: "grey #e0e0e0",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                  width: "6px", // For WebKit-based browsers
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                  background: "#f1f1f1", // Track color
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                  backgroundColor: "grey", // Thumb color
                  borderRadius: "10px",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#555",
                },
              }}
            />
            <TableContainer
              component={Paper}
              style={{ maxHeight: "500px", overflowY: "auto" }}
              className="custom-sidebar-scrollbar"
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {[
                      "S.No",
                      "Registered Date",
                      "Organization Name",
                      "Email Id",
                      "Mobile No",
                      "Address",
                      "Board",
                    //   "Feature",
                    //    "Plan",
                    //    "Students",
                    //    "Employees",
                    //    "Plan",
                    ].map((header) => (
                      <TableCell
                        key={header}
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          backgroundColor: "#fff9c4",
                          fontWeight: "Bold",
                          fontSize: "14px",
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loader ? (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                        >
                          <CircularProgress />
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            Loading Data...
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : organization.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No data available
                      </TableCell>
                    </TableRow>
                  ) : (
                    organization.map((employee, index) => (
                      <TableRow
                        key={employee.id}
                        sx={{
                          backgroundColor: "white",
                          transition: "background-color 0.3s",
                          "&:hover": { backgroundColor: "#f5f5f5" }, // Hover effect
                         
                        }}
                      >
                        <TableCell
                          sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "Center", // left-aligned looks better for long text
    maxWidth: "100px", // increase width if needed
    minWidth: "40px",
    whiteSpace: "normal",  // allow wrapping
    // wordBreak: "break-word", // break long words
    color: "black",
    fontSize: "13px",
  }}
                        >
                          {index + 1}
                        </TableCell>


                        <TableCell
                          sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "Center", // left-aligned looks better for long text
    maxWidth: "150px", // increase width if needed
    minWidth: "100px",
    color: "black",
    fontSize: "13px",
  }}
                        >
                          {employee.joinDate}
                        </TableCell>

                        <TableCell
                          sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "Center", // left-aligned looks better for long text
    maxWidth: "150px", // increase width if needed
    minWidth: "100px",
    whiteSpace: "normal",  // allow wrapping
    wordBreak: "break-word", // break long words
    color: "black",
    fontSize: "13px",
  }}
                        >
                          {employee.schoolName}
                        </TableCell>

                       <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "Center", // left-aligned looks better for long text
    maxWidth: "150px", // increase width if needed
    minWidth: "100px",
    whiteSpace: "normal",  // allow wrapping
    wordBreak: "break-word", // break long words
    color: "black",
    fontSize: "13px",
  }}
 
>
  {employee.schoolEmailId || "NA"}
</TableCell>

                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                             color:"black",
                            fontSize:'13px'
                          }}
                        >
                          {employee.primaryContact || "NA"}
                        </TableCell>
                       
                       <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "Center", // left-aligned looks better for long text
    maxWidth: "150px", // increase width if needed
    minWidth: "100px",
    whiteSpace: "normal",  // allow wrapping
    wordBreak: "break-word", // break long words
    color: "black",
    fontSize: "13px",
  }}
>
  {employee.schoolAddress || "NA"}
</TableCell>
 <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                             color:"black",
                            fontSize:'13px'
                          }}
                        >
                          {employee.boardAffiliation || "NA"}
                        </TableCell>


                        {/* <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                             color:"black",
                            fontSize:'13px'
                          }}
                        >
                          {employee.feature || "NA"}
                        </TableCell>

 <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                             color:"black",
                            fontSize:'13px'
                          }}
                        >
                          {employee.plan || "NA"}
                        </TableCell>
                         <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                             color:"black",
                            fontSize:'13px'
                          }}
                        >
                          {employee.totalPresentStudents || "NA"}
                        </TableCell>
                         <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                             color:"black",
                            fontSize:'13px'
                          }}
                        >
                          {employee.totalPresentEmployees || "NA"}
                        </TableCell> */}
                         {/* <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                             color:"black",
                            fontSize:'13px'
                          }}
                        >
                          {employee.feature || "NA"}
                        </TableCell> */}


           


                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Box>

   
      <ToastContainer />
    </Box>
  );
};


export default SuperAdminDashboard;